<template>
  <div>
    <!-- 탭 버튼 섹션 -->
    <v-sheet outlined class="ma-2 pa-2 mb-2">
      <v-btn-toggle v-model="selectedTab" color="primary" group>
        <v-btn value="monthly">월별</v-btn>
        <v-btn value="promotion">프로모션별</v-btn>
      </v-btn-toggle>
    </v-sheet>

    <!-- 월별 프로모션 판매 내역 섹션 -->
    <v-sheet v-show="selectedTab === 'monthly'" outlined class="ma-2 pa-2 mb-2">
      <div class="d-flex align-center mb-2">
        <span>{{ selectedYear }}년 월별 프로모션 판매 내역</span>
        <v-sheet width="200" class="mx-6">
          <v-select :items="monthOptions" item-text="text" item-value="value" v-model="selectedMonth" label="월 선택"></v-select>
        </v-sheet>
      </div>

      <v-data-table :headers="monthlyTableHeaders" :items="monthlyItems" hide-default-footer :items-per-page="-1" :loading="isMonthlyLoading" loading-text="Loading... Please wait" class="mb-2">
        <template v-slot:[`item.promotionCode`]="{ item }">
          <div>
            <div class="font-weight-medium">{{ getPromotionName(item.promotionCode) }}</div>
            <div class="text-caption text--secondary">{{ item.promotionCode }}</div>
          </div>
        </template>
        <template v-slot:[`item.payed_amount`]="{ item }">
          <span>{{ $toComma(item.payed_amount) }}원</span>
        </template>
        <template v-slot:[`item.cancel_amount`]="{ item }">
          <span>{{ $toComma(item.cancel_amount) }}원</span>
        </template>
        <template v-slot:[`item.total_amount`]="{ item }">
          <span>{{ $toComma(item.total_amount) }}원</span>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn small depressed color="primary" outlined @click="openDetailFromMonthly(item)">세부내역서</v-btn>
        </template>
      </v-data-table>
    </v-sheet>

    <!-- 프로모션별 판매 내역 섹션 -->
    <div v-show="selectedTab === 'promotion'">
      <v-sheet outlined class="ma-2 pa-2 mb-2 d-flex align-center">
        <span>프로모션 선택 {{ selectedYear }}년</span>
        <v-sheet width="300" class="mx-6">
          <v-select :items="promotions" :item-text="(item) => item.name || item.code" item-value="code" v-model="selectedPromotion"></v-select>
        </v-sheet>
      </v-sheet>

      <!-- 본문 -->
      <v-sheet outlined class="pa-2 ma-2">
        <v-data-table :headers="tableHeaders" :items="items" hide-default-footer :items-per-page="-1" :loading="isLoading" loading-text="Loading... Please wait">
          <template v-slot:[`item.date`]="{ item }">
            <span>{{ Number(item.date.split("-")[1]) }}월</span>
          </template>
          <template v-slot:[`item.payed_amount`]="{ item }">
            <span>{{ $toComma(item.payed_amount) }}원</span>
          </template>
          <template v-slot:[`item.cancel_amount`]="{ item }">
            <span>{{ $toComma(item.cancel_amount) }}원</span>
          </template>
          <template v-slot:[`item.total_amount`]="{ item }">
            <span>{{ $toComma(item.total_amount) }}원</span>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn small depressed color="primary" outlined @click="openDetail(item)">세부내역서</v-btn>
          </template>
        </v-data-table>
      </v-sheet>
    </div>
  </div>
</template>
<script>
import statusService from "@/api/stats-service"
export default {
  props: {
    selectedYear: {
      type: String,
      default: "2025",
    },
  },
  watch: {
    selectedYear: {
      immediate: true, // 컴포넌트가 생성될 때도 실행
      handler(newVal) {
        this.load()
        this.loadMonthlyData() // 년도 변경시 월별 데이터도 다시 로드
      },
    },
    selectedPromotion() {
      this.load()
    },
    selectedMonth() {
      this.loadMonthlyData() // 월 변경시 월별 데이터 다시 로드
    },
  },
  data: () => ({
    selectedTab: "monthly", // 기본값을 월별로 설정
    promotions: [],
    selectedPromotion: null,

    // 월별 데이터 관련
    selectedMonth: new Date().getMonth() + 1, // 현재 월을 기본값으로
    monthOptions: [
      { text: "1월", value: 1 },
      { text: "2월", value: 2 },
      { text: "3월", value: 3 },
      { text: "4월", value: 4 },
      { text: "5월", value: 5 },
      { text: "6월", value: 6 },
      { text: "7월", value: 7 },
      { text: "8월", value: 8 },
      { text: "9월", value: 9 },
      { text: "10월", value: 10 },
      { text: "11월", value: 11 },
      { text: "12월", value: 12 },
    ],
    isMonthlyLoading: false,
    monthlyItems: [],
    monthlyTableHeaders: [
      { value: "promotionCode", text: "프로모션" },
      { value: "payed_amount", text: "결제 금액", align: "right" },
      { value: "cancel_amount", text: "취소 금액", align: "right" },
      { value: "total_amount", text: "매출 합계", align: "right" },
      { text: "세부내역", value: "actions", width: "150px", sortable: false },
    ],

    isLoading: false,
    items: [],
    totalAmount: 0,
    tableHeaders: [
      { value: "date", text: "날짜" },
      { value: "payed_amount", text: "결제 금액", align: "right" },
      { value: "cancel_amount", text: "취소 금액", align: "right" },
      { value: "total_amount", text: "매출 합계", align: "right" },
      { text: "세부내역", value: "actions", width: "150px", sortable: false },
    ],
  }),
  created() {
    this.loadPromotions()
    this.loadMonthlyData() // 월별 데이터 초기 로드
  },
  mounted() {},
  methods: {
    loadPromotions() {
      this.$http.post("/api/promotion/select/search").then((res) => {
        this.promotions = res.data.filter((e) => e.role !== "TRAVELER")
      })
    },

    getPromotionName(code) {
      const promotion = this.promotions.find((p) => p.code === code)
      return promotion ? promotion.name : code === "default" || code === null || code === undefined || code === "" ? "기본" : code
    },

    mergeNullAndDefaultPromotions(data) {
      let nullItem = null
      let defaultItem = null
      const otherItems = []

      // null과 'default'인 항목을 찾고 나머지는 그대로 유지
      data.forEach((item) => {
        if (item.promotionCode === null) {
          nullItem = item
        } else if (item.promotionCode === "default") {
          defaultItem = item
        } else {
          otherItems.push(item)
        }
      })

      // 'default' 항목이 있으면 null 항목에 합산하고 'default' 항목은 제거
      if (defaultItem && nullItem) {
        nullItem.payed_amount = (parseInt(nullItem.payed_amount) || 0) + (parseInt(defaultItem.payed_amount) || 0)
        nullItem.cancel_amount = (parseInt(nullItem.cancel_amount) || 0) + (parseInt(defaultItem.cancel_amount) || 0)
        nullItem.total_amount = (parseInt(nullItem.total_amount) || 0) + (parseInt(defaultItem.total_amount) || 0)
        nullItem.reservation_count = (parseInt(nullItem.reservation_count) || 0) + (parseInt(defaultItem.reservation_count) || 0)
      } else if (defaultItem && !nullItem) {
        // null 항목이 없고 default만 있는 경우, default를 null로 변경
        defaultItem.promotionCode = null
        nullItem = defaultItem
      }

      // 결과 배열 구성
      const result = []
      if (nullItem) {
        result.push(nullItem)
      }

      // otherItems를 promotionCode로 정렬
      const sortedOtherItems = otherItems.sort((a, b) => {
        if (a.promotionCode < b.promotionCode) return -1
        if (a.promotionCode > b.promotionCode) return 1
        return 0
      })

      result.push(...sortedOtherItems)

      return result
    },

    async loadMonthlyData() {
      try {
        this.isMonthlyLoading = true
        const at = `${this.selectedYear}-${String(this.selectedMonth).padStart(2, "0")}`

        const result = await statusService.getPromotionSalesStatsWithMonth(at)
        console.log("Monthly promotion data:", result)

        // null과 'default' promotionCode를 합치는 로직
        const processedResult = this.mergeNullAndDefaultPromotions(result)
        this.monthlyItems = processedResult
      } catch (e) {
        console.log(e)
        alert("월별 데이터를 가져오지 못했습니다.")
      } finally {
        this.isMonthlyLoading = false
      }
    },

    async load() {
      if (!this.selectedPromotion) {
        return
      }

      try {
        this.isLoading = true
        const from = this.dayjs().year(this.selectedYear).startOf("year").format("YYYY-MM-DD")
        const to = this.dayjs().year(this.selectedYear).endOf("year").format("YYYY-MM-DD")

        //const from = this.dayjs().startOf("year").format("YYYY-MM-DD")
        //const to = this.dayjs(this.defaultPrice.endAt).format("YYYY-MM-DD")

        const result = await statusService.getPromotionSalesStats(true, from, to, this.selectedPromotion)
        console.log(result)
        this.items = result
        this.totalAmount = this.items.reduce((sum, e) => sum + Number(e.total_amount), 0)
      } catch (e) {
        console.log(e)
        alert("데이터를 가져오지 못했습니다.")
      } finally {
        this.isLoading = false
      }
    },
    openDetailFromMonthly(item) {
      console.log(`openDetailFromMonthly`, item)
      console.log(`this.selectedMonth`, this.selectedMonth)
      const fakeItem = {
        cancel_amount: item.cancel_amount,
        payed_amount: item.payed_amount,
        total_amount: item.total_amount,
        date: `${this.selectedYear}-${String(this.selectedMonth).padStart(2, "0")}`,
      }
      this.$emit("openFromMonthly", { month: this.selectedMonth, code: item.promotionCode || "default", item: fakeItem })
    },
    openDetail(item) {
      console.log(`openDetail`, item)
      this.$emit("open", { item, code: this.selectedPromotion })
    },
  },
}
</script>
<style></style>
